import { Button, makeStyles, tokens } from '@fluentui/react-components';
import type { ReactNode } from 'react';

const useStyles = makeStyles({
  root: {
    position: 'fixed',
    left: '0',
    right: '0',
    bottom: '0',
    zIndex: 1,
    padding: tokens.spacingVerticalM,
    backgroundColor: tokens.colorNeutralBackground1,
    borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  button: {
    width: '100%',
    minHeight: '3rem',
    borderRadius: tokens.borderRadiusMedium,
  },
});

export type StickyActionFooterProps = {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  children?: ReactNode;
};

export function StickyActionFooter({
  label,
  onClick,
  disabled = false,
  loading = false,
  children,
}: StickyActionFooterProps) {
  const styles = useStyles();
  return (
    <footer className={styles.root}>
      {children}
      <Button
        className={styles.button}
        appearance="primary"
        disabled={disabled || loading}
        onClick={onClick}
      >
        {loading ? 'Loading...' : label}
      </Button>
    </footer>
  );
}
